import { ref } from "vue";

const STORAGE_KEY = "app_theme";

// Estado partilhado a nível de módulo — todos os componentes veem o mesmo tema
const theme = ref(localStorage.getItem(STORAGE_KEY) === "light" ? "light" : "dark");

function applyBodyClass() {
  // O fundo do body é definido em index.css com !important;
  // body.theme-light (especificidade maior) sobrepõe-o no tema claro
  document.body.classList.toggle("theme-light", theme.value === "light");
}

applyBodyClass();

export function useTheme() {
  const setTheme = (value) => {
    theme.value = value === "light" ? "light" : "dark";
    localStorage.setItem(STORAGE_KEY, theme.value);
    applyBodyClass();
  };

  const toggleTheme = () => {
    setTheme(theme.value === "light" ? "dark" : "light");
  };

  return { theme, setTheme, toggleTheme };
}
